var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mx-3 mapTitle py-6 mb-6 d-flex justify-space-between align-center"},[_c('div',[_c('span',{staticClass:"ct-text-subtitle3 ct-text-bolder mapTree"},[_vm._v(_vm._s(_vm.title))])]),_c('div',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }